var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStatistic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 119h-114c-1.104 0-2-0.9-2-2v-114c0-1.104 0.896-2 2-2s2 0.896 2 2v112h112c1.104 0 2 0.9 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23h-8c-1.104 0-2-0.896-2-2s0.896-2 2-2h8c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35h-8c-1.104 0-2-0.896-2-2s0.896-2 2-2h8c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47h-8c-1.104 0-2-0.896-2-2s0.896-2 2-2h8c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 59h-8c-1.104 0-2-0.896-2-2s0.896-2 2-2h8c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.664 97.58c-6.616 0-12-5.384-12-12 0-6.608 5.384-12 12-12s12 5.392 12 12c0 6.616-5.384 12-12 12zM28.664 77.58c-4.416 0-8 3.588-8 8 0 4.416 3.584 8 8 8s8-3.584 8-8c0-4.412-3.584-8-8-8z",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.664 82.58c-6.612 0-12-5.384-12-12 0-6.608 5.388-12 12-12s12 5.384 12 12c0 6.616-5.388 12-12 12zM78.664 62.58c-4.416 0-8 3.588-8 8 0 4.416 3.584 8 8 8s8-3.584 8-8c0-4.412-3.58-8-8-8z",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.664 27.58c-6.612 0-12-5.384-12-12s5.388-12 12-12 12 5.384 12 12-5.388 12-12 12zM108.664 7.58c-4.416 0-8 3.588-8 8s3.584 8 8 8 8-3.588 8-8-3.58-8-8-8z",
    fill: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.448 63.812c-0.324 0-0.652-0.080-0.956-0.244-0.968-0.536-1.328-1.752-0.796-2.724l20.432-37.464c0.528-0.968 1.752-1.328 2.716-0.8 0.968 0.528 1.328 1.744 0.796 2.712l-20.432 37.46c-0.364 0.676-1.052 1.060-1.76 1.060z",
    fill: "#000000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.664 84.972c-0.852 0-1.64-0.552-1.908-1.412-0.328-1.060 0.256-2.172 1.312-2.5l30-9.288c1.072-0.328 2.18 0.256 2.508 1.32 0.32 1.056-0.26 2.172-1.32 2.5l-30 9.288c-0.192 0.064-0.396 0.092-0.592 0.092z",
    fill: "#000000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.092 110.92c-0.416 0-0.832-0.128-1.192-0.404-0.892-0.66-1.072-1.916-0.416-2.792l11.132-14.944c0.656-0.884 1.916-1.080 2.792-0.416 0.884 0.66 1.076 1.916 0.412 2.796l-11.124 14.948c-0.388 0.532-0.988 0.812-1.604 0.812z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatistic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Statistic.027d9336.svg";
export { ForwardRef as ReactComponent };